import { environment as devEnvironment } from './environment.dev';

export const environment = devEnvironment;
